import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import MultiSelect from 'react-multi-select-component';
import PropertyList, { FilterType } from '../../domain/models/property-list';
import useDebounce from '../../utils/use-debounce';

const Container = styled.div`
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serfif;
`;
const Items = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-wrap: wrap;
`;
const MultiSelectContainer = styled.div`
  width: 100%;
  padding-right: 1rem;
  h5 {
    margin-bottom: 0.5rem;
  }
  label {
  }
  input {
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
  }
`;
const ExtraContainer = styled.div`
  width: 100%;
  display: flex;
`;
const SearchContainer = styled.div`
  width: 100%;
  padding-right: 1rem;
  h5 {
    margin-bottom: 0.5rem;
  }
  input {
    width: 100%;
    height: 40px;
    border: 1px solid #cccccc;
    border-radius: 4px;
    padding: 0px 8px;
  }
  div {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  a {
    color: #000000;
    transition: all 500ms;
    margin-left: 1rem;
  }
`;
const PopularSearchContainer = styled.div`
  padding-top: 1rem;
  display: flex;
  flex-wrap: wrap;
  span {
    margin-right: 1.5rem;
    white-space: nowrap;
  }
`;

type PropsType = {
  propertyLists: PropertyList[];
  onFilterChanged: (filter: FilterType) => void;
  onTextFilterChanged: (textFilter: string) => void;
  defaultSelected: FilterType;
  defaultTextFilter: string;
  defaultSearchPlaceholderText?: string;
  professions?: string[];
};

function ClientFilters(props: PropsType) {
  const {
    propertyLists,
    onFilterChanged,
    onTextFilterChanged,
    defaultSelected,
    defaultTextFilter,
    defaultSearchPlaceholderText,
    professions
  } = props;
  const [selected, setSelected] = useState({});
  const [searchText, setSearchText] = useState('');
  const debouncedSearchText = useDebounce(searchText, 500);

  let searchPlaceholderText = defaultSearchPlaceholderText;
  if (!defaultSearchPlaceholderText) {
    searchPlaceholderText = 'Type name of client';
  }

  useEffect(() => {
    setSelected(defaultSelected);
    setSearchText(defaultTextFilter);
  }, []);

  useEffect(() => {
    onFilterChanged(selected);
  }, [selected]);

  useEffect(() => {
    onTextFilterChanged(debouncedSearchText);
  }, [debouncedSearchText]);

  const options = (propertyList) => {
    if (propertyList?.properties) {
      const properties = propertyList.properties.map((p) => ({
        label: p.title,
        value: p.id,
        priority: p.priority
      }));
      properties.sort((a, b) => {
        const textA = a.label.toUpperCase();
        const textB = b.label.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
      properties.sort((a, b) => b.priority - a.priority);
      return properties;
    }
    return [];
  };

  const onChange = (id, data) => {
    if (data.length == 0) {
      delete selected[id];
    } else {
      selected[id] = data;
    }
    setSelected({ ...selected });
  };

  const onSearchChange = (e: { target: HTMLInputElement }) => {
    setSearchText(e.target.value);
  };

  const clearSearchText = (e) => {
    e.preventDefault();
    setSearchText('');
    onTextFilterChanged('');
  };

  const isChecked = (option: any, selectedOptions) => {
    const index = selectedOptions.findIndex((o) => o.value == option.value);
    return index >= 0;
  };

  const onCheckChanged = (propertyListId: number, option: any, selectedOptions) => {
    const checked = isChecked(option, selectedOptions);
    if (!selected[propertyListId]) {
      selected[propertyListId] = [];
    }
    if (checked) {
      selected[propertyListId] = selected[propertyListId].filter((o) => o.value != option.value);
    } else {
      selected[propertyListId].push(option);
    }
    if (selected[propertyListId].length == 0) {
      delete selected[propertyListId];
    }
    setSelected({ ...selected });
  };

  const renderList = (propertyList: PropertyList) => {
    return (
      <>
        <h5>{propertyList.title}</h5>
        {/* <MultiSelect
          options={options(propertyList)}
          value={selected[propertyList.id] || []}
          onChange={(data) => onChange(propertyList.id, data)}
          labelledBy="Select"
        /> */}
        <div>
          {options(propertyList).map((o) => (
            <div key={o.value}>
              <label>
                <input
                  name={o.value}
                  type="checkbox"
                  checked={isChecked(o, selected[propertyList.id] || [])}
                  onChange={() =>
                    onCheckChanged(propertyList.id, o, selected[propertyList.id] || [])
                  }
                />
                {o.label}
              </label>
            </div>
          ))}
        </div>
      </>
    );
  };

  const renderLists = (propertyLists: PropertyList[]) => {
    if (propertyLists) {
      return propertyLists.map((p) => (
        <MultiSelectContainer key={p.id}>{renderList(p)}</MultiSelectContainer>
      ));
    }
    return <div />;
  };

  return (
    <Container>
      <Items>
        <ExtraContainer>
          <SearchContainer>
            <h5>Search</h5>
            <div>
              <input
                type="text"
                placeholder={searchPlaceholderText}
                value={searchText}
                onChange={onSearchChange}
              />
              <a
                href="#"
                onClick={clearSearchText}
                style={searchText ? {} : { opacity: 0.2, color: '#000000' }}>
                Clear
              </a>
            </div>
          </SearchContainer>
        </ExtraContainer>
        {renderLists(propertyLists)}
        {/* {propertyLists && propertyLists.map((p) => (
          <MultiSelectContainer key={p.id}>
            <h5>{p.title}</h5>
            <MultiSelect
              options={options(p)}
              value={selected[p.id] || []}
              onChange={(data) => onChange(p.id, data)}
              labelledBy="Select"
            />
          </MultiSelectContainer>
        ))} */}
        {/* {professions && (
          <ExtraContainer>
            <PopularSearchContainer>
              <span>Popular Searches</span>
              {professions.map((p, i) => (
                <div key={i}>
                  <a
                    href={`/celebrity?text_filter=${p.toLowerCase()}`}
                    onClick={(e) => {
                      e.preventDefault();
                      setSearchText(p.toLowerCase());
                    }}>
                    <span>{p}</span>
                  </a>
                </div>
              ))}
            </PopularSearchContainer>
          </ExtraContainer>
        )} */}
      </Items>
    </Container>
  );
}

export default ClientFilters;
